import styled from 'styled-components';
export const LinkListBase = styled.ul `
  display: flex;
  flex-direction: column;
  list-style: none;
  padding-inline-start: 0;

  li {
    border-top: 1px solid var(--color-border);

    &:last-child {
      border-bottom: 1px solid var(--color-border);
    }

    & > a {
      display: flex;
      justify-content: space-between;
      align-items: center;

      padding: 16px 0;

      color: var(--color-on-background);
      text-decoration: none;

      &:hover,
      &:focus-visible {
        color: var(--color-primary-variant);
        background: var(--color-overlay-hover-darken);
      }

      &:active {
        color: var(--color-primary-variant);
        background: var(--color-overlay-pressed-darken);
      }

      &[aria-disabled='true'] {
        color: var(--color-disabled);
        pointer-events: none;
      }

      & > i {
        font-size: 24px;
        line-height: 24px;
      }
    }
  }
`;
